export default __webpack_public_path__ + "static/media/bg.aa352552.jpg";